import { DeviceTypes } from '@eppendorf/app-configs';
import { ReactElement } from 'react';

import { LabelDescriptionItem } from '$components/label-description-item/label-description-item';
import { searchDeviceIcon } from '$features/devices/devices.utils';

type DeviceListItemProps = {
  name: string;
  model?: string;
  type: DeviceTypes;
};

export function DeviceListItem({ name, model, type }: DeviceListItemProps): ReactElement {
  return (
    <LabelDescriptionItem
      label={name}
      description={model}
      iconName={searchDeviceIcon(type as string)}
    />
  );
}
